"use client";

import React from "react";
import { Facebook, Video, Play, Users, ExternalLink, Instagram } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tiktokFeed = [{
  id: 1,
  views: "15.1K",
  title: "Συντάξεις ΕΔ & ΣΑ"
}, {
  id: 2,
  views: "5.6K",
  title: "Διαδικασία Ενδικοφανών"
}, {
  id: 3,
  views: "2.3K",
  title: "Ωράριο & Υπερωρίες"
}, {
  id: 4,
  views: "1.9K",
  title: "Χορήγηση Δεύτερης Ειδικότητας"
}, {
  id: 5,
  views: "12.4K",
  title: "Τακτικές Μεταθέσεις"
}, {
  id: 6,
  views: "9.8K",
  title: "Πειθαρχικά Θέματα"
}];
const fbStats = [{
  id: 1,
  label: "Ενεργά Μέλη",
  value: "17.100+"
}, {
  id: 2,
  label: "Ημερήσιες Συζητήσεις",
  value: "50+"
}];
export default function SeeUsOnSocialMedia() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="157996" id="δείτε-μας-στα-social-media" className="dark bg-background text-foreground py-24 px-4 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold mb-6 text-white">
            Δείτε μας στα Social Media
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default">
            Ακολουθήστε μας στα κοινωνικά δίκτυα για άμεση ενημέρωση, πρακτικές συμβουλές και συμμετοχή στη μεγαλύτερη κοινότητα στελεχών.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <Link to="https://www.tiktok.com/@sinigorostouenstolou" newTab className="group block h-full outline-none">
            <Card className="h-full min-h-[500px] bg-[#171F26] backdrop-blur-md border-[#1AE664]/20 transition-all duration-500 group-hover:shadow-[0_0_50px_rgba(26,230,100,0.2)] group-hover:border-primary/50 overflow-hidden relative flex flex-col">
              <div className="absolute inset-0 bg-gradient-to-br from-black/60 to-transparent pointer-events-none" />
              
              <CardHeader className="pb-6 relative z-10">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-lg bg-[#0E1B13] flex items-center justify-center text-[#1AE664] shadow-lg border border-[#1AE664]/20 group-hover:scale-110 transition-transform duration-500">
                      <Video className="w-7 h-7" />
                    </div>
                    <div>
                      <CardTitle className="text-3xl font-default font-bold text-white mb-1">TikTok</CardTitle>
                      <CardDescription className="text-base text-[#ADADAD] font-default">@sinigorostouenstolou</CardDescription>
                    </div>
                  </div>
                  <Button variant="outline" size="icon" className="rounded-sm bg-transparent border-white/20 text-white group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary transition-all duration-300" asChild>
                    <span>
                      <ExternalLink className="w-5 h-5" />
                    </span>
                  </Button>
                </div>
              </CardHeader>
              
              <CardContent className="relative z-10 flex-1 flex flex-col">
                <div className="bg-black/40 rounded-lg p-5 border border-white/5 flex-1 shadow-inner">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-sm font-medium text-white/80 font-default">Τελευταία Βίντεο</span>
                    <Badge variant="secondary" className="bg-primary/20 text-primary hover:bg-primary/30 border-none font-default">
                      Ενημέρωση
                    </Badge>
                  </div>
                  <ScrollArea className="h-[320px] pr-4 -mr-4">
                    <div className="grid grid-cols-2 gap-4 pb-4">
                      {tiktokFeed.map((video, i) => <div key={video.id} data-index={i} className="relative aspect-[9/16] bg-muted/10 rounded-md overflow-hidden group/video border border-white/5">
                          <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent z-10" />
                          <div className="absolute inset-0 flex items-center justify-center z-20">
                            <div className="w-10 h-10 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center border border-white/20 group-hover/video:bg-primary group-hover/video:border-primary transition-colors duration-300">
                              <Play className="w-4 h-4 text-white ml-1" />
                            </div>
                          </div>
                          <div className="absolute bottom-3 left-3 right-3 z-20">
                            <p className="text-xs text-white font-default font-medium line-clamp-2 mb-2 leading-tight">
                              {video.title}
                            </p>
                            <div className="flex items-center text-[10px] text-[#ADADAD] font-default font-medium">
                              <Play className="w-3 h-3 mr-1 text-[#1AE664]" /> {video.views}
                            </div>
                          </div>
                        </div>)}
                    </div>
                  </ScrollArea>
                </div>
              </CardContent>
            </Card>
          </Link>

          {}
          <Link to="https://www.facebook.com/sinigorostouenstolou" newTab className="group block h-full outline-none">
            <Card className="h-full min-h-[500px] bg-[#171F26] backdrop-blur-md border-[#1AE664]/20 transition-all duration-500 group-hover:shadow-[0_0_50px_rgba(26,230,100,0.2)] group-hover:border-primary/50 overflow-hidden relative flex flex-col">
              <div className="absolute inset-0 bg-gradient-to-bl from-[#1877F2]/10 to-transparent pointer-events-none" />
              
              <CardHeader className="pb-6 relative z-10">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-lg bg-[#1877F2] flex items-center justify-center text-white shadow-lg border border-white/10 group-hover:scale-110 transition-transform duration-500">
                      <Facebook className="w-7 h-7" />
                    </div>
                    <div>
                      <CardTitle className="text-3xl font-default font-bold text-white mb-1">Facebook</CardTitle>
                      <CardDescription className="text-base text-[#ADADAD] font-default">Συνήγορος του Ένστολου</CardDescription>
                    </div>
                  </div>
                  <Button variant="outline" size="icon" className="rounded-sm bg-transparent border-white/20 text-white group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary transition-all duration-300" asChild>
                    <span>
                      <ExternalLink className="w-5 h-5" />
                    </span>
                  </Button>
                </div>
              </CardHeader>
              
              <CardContent className="relative z-10 flex-1 flex flex-col justify-center items-center p-8">
                <div className="w-full max-w-sm bg-black/40 rounded-2xl p-8 border border-white/5 shadow-2xl text-center relative overflow-hidden">
                  {}
                  <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#1AE664]/10 rounded-full blur-2xl" />
                  <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
                  
                  <div className="relative z-10">
                    <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 text-primary mb-6 relative group-hover:scale-110 transition-transform duration-500">
                      <Users className="w-10 h-10" />
                      <div className="absolute top-0 right-0 bg-[#1AE664] text-[#0E1B13] text-[10px] font-bold px-2 py-1 rounded-full animate-pulse shadow-lg border border-[#1AE664]/20">
                        LIVE
                      </div>
                    </div>
                    
                    <div className="mb-8">
                      <h3 className="text-6xl font-default font-bold text-white mb-2 tracking-tighter drop-shadow-md">17K<span className="text-primary" data-ast-id="f:/src/pages/Home/sections/SeeUsOnSocialMedia.tsx|sig:p8yc2l" data-ast-start="9371" data-ast-end="9410">+</span></h3>
                      <p className="text-lg text-[#ADADAD] font-default font-medium">
                        Μέλη στην Κοινότητα
                      </p>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      {fbStats.map((stat, i) => <div key={stat.id} data-index={i} className="bg-white/5 px-4 py-4 rounded-lg border border-white/10 backdrop-blur-sm">
                          <div className="text-2xl font-default font-bold text-white mb-1">{stat.value}</div>
                          <div className="text-[10px] text-[#ADADAD] font-default uppercase tracking-widest font-semibold">
                            {stat.label}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Link>

          {}
          <Link to="https://www.instagram.com/sinigorostouenstolou" newTab className="group block h-full outline-none">
            <Card className="h-full min-h-[500px] bg-[#171F26] backdrop-blur-md border-[#1AE664]/20 transition-all duration-500 group-hover:shadow-[0_0_50px_rgba(26,230,100,0.2)] group-hover:border-primary/50 overflow-hidden relative flex flex-col">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#E4405F]/10 to-transparent pointer-events-none" />
              
              <CardHeader className="pb-6 relative z-10">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-lg bg-[#E4405F] flex items-center justify-center text-white shadow-lg border border-white/10 group-hover:scale-110 transition-transform duration-500">
                      <Instagram className="w-7 h-7" />
                    </div>
                    <div>
                      <CardTitle className="text-3xl font-default font-bold text-white mb-1">Instagram</CardTitle>
                      <CardDescription className="text-base text-[#ADADAD] font-default">@sinigorostouenstolou</CardDescription>
                    </div>
                  </div>
                  <Button variant="outline" size="icon" className="rounded-sm bg-transparent border-white/20 text-white group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary transition-all duration-300" asChild>
                    <span>
                      <ExternalLink className="w-5 h-5" />
                    </span>
                  </Button>
                </div>
              </CardHeader>
              
              <CardContent className="relative z-10 flex-1 flex flex-col justify-center items-center p-8">
                <div className="w-full max-w-sm bg-black/40 rounded-2xl p-8 border border-white/5 shadow-2xl text-center relative overflow-hidden">
                  <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#E4405F]/10 rounded-full blur-2xl" />
                  <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
                  
                  <div className="relative z-10">
                    <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-[#E4405F]/20 to-[#E4405F]/5 border border-[#E4405F]/30 text-[#E4405F] mb-6 relative group-hover:scale-110 transition-transform duration-500">
                      <Instagram className="w-10 h-10" />
                    </div>
                    
                    <div className="mb-8">
                      <h3 className="text-4xl font-default font-bold text-white mb-2 tracking-tighter drop-shadow-md">
                        Follow Us
                      </h3>
                      <p className="text-base text-[#ADADAD] font-default font-medium">
                        Για καθημερινή ενημέρωση & stories
                      </p>
                    </div>

                    <div className="grid grid-cols-3 gap-2">
                      {[1, 2, 3].map((item, i) => <div key={item} data-index={i} className="aspect-square bg-white/5 rounded-lg border border-white/10 backdrop-blur-sm">
                        </div>)}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>;
}